export const SERVICES = [
    {
        icon: "🩺",
        title: "Allgemeinmedizin",
        desc: "Diagnose und Behandlung akuter und chronischer Erkrankungen",
    },
    {
        icon: "❤️",
        title: "Vorsorge & Check-up",
        items: [
            "Ruhe-EKG",
            "Langzeit-Blutdruckmessung",
            "Sonographie Bauchorgane",
            "D-Dimer (Thrombose / Lungenembolie)",
            "Troponin (Herzinfarkt)",
            "Disease-Management-Programm – DMP (Diabetes / COPD)",
        ],
    },
    {
        icon: "💆",
        title: "Therapeutischer Ansatz",
        items: [
            "Massage",
            "Elektrotherapie",
        ],
    },
    {
        icon: "🔬",
        title: "Krebsvorsorge & Diagnostik",
        items: [
            "Hautkrebsscreening (alle 2 Jahre)",
            "Gesundheitsuntersuchung Blut & Urin (alle 3 Jahre ab 35, einmalig 18–35 J.)",
            "Männerkrebsvorsorge ab 45 Jahren jährlich",
            "Darmkrebsvorsorge ab 50 Jahren (Stuhluntersuchung)",
            "Bauchaortenaneurysma-Screening",
        ],
    },
    {
        icon: "📋",
        title: "Attest & Gutachten",
        desc: "Ausstellung von Arbeitsunfähigkeitsbescheinigungen, Sportattesten und ärztlichen Gutachten.",
    },
    {
        icon: "✈️",
        title: "Reisemedizin & Weitere",
        items: [
            "Impfungen & Reiseberatung",
            "Sporttauchtauglichkeitsuntersuchung",
            "Führerscheinuntersuchungen",
        ],
    },
];

export function Services() {
    return (
        <section id="leistungen" className="section section--alt">
            <div className="divider"/>
            <h2 className="section-title">Unsere Leistungen</h2>
            <p className="section-sub">Umfassende medizinische Versorgung für alle Altersgruppen</p>

            <div className="services-grid">
                {SERVICES.map(({icon, title, desc, items}) => (
                    <div className="service-card" key={title}>
                        <div className="service-card__header">
                            <div className="service-card__icon-wrap">
                                <span className="service-card__icon">{icon}</span>
                            </div>
                            <h3 className="service-card__title">{title}</h3>
                        </div>
                        <div className="service-card__divider"/>
                        {desc && (
                            <p className="service-card__desc">{desc}</p>
                        )}
                        {items && (
                            <ul className="service-card__list">
                                {items.map((item) => (
                                    <li key={item}>
                                        <span className="service-card__check">✓</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}